module.exports = __webpack_public_path__ + "img/private-pizzeriano3-nudeln.9314cc46.jpg";